export enum DirectionalHint {
  /**
   * Appear above the target element, with the left edges of the callout and target aligning.
   */
  topLeftEdge,

  /**
   * Appear above the target element, with the centers of the callout and target aligning.
   */
  topCenter,

  /**
   * Appear above the target element, with the right edges of the callout and target aligning.
   */
  topRightEdge,

  /**
   * Appear above the target element, aligning with the target element such that the callout tends toward the center of the screen.
   */
  topAutoEdge,

  /**
   * Appear below the target element, with the left edges of the callout and target aligning.
   */
  bottomLeftEdge,

  /**
   * Appear below the target element, with the centers of the callout and target aligning.
   */
  bottomCenter,

  /**
   * Appear below the target element, with the right edges of the callout and target aligning.
   */
  bottomRightEdge,

  /**
   * Appear below the target element, aligning with the target element such that the callout tends toward the center of the screen.
   */
  bottomAutoEdge,

  /**
   * Appear to the left of the target element, with the top edges of the callout and target aligning.
   */
  leftTopEdge,

  /**
   * Appear to the left of the target element, with the centers of the callout and target aligning.
   */
  leftCenter,

  /**
   * Appear to the left of the target element, with the bottom edges of the callout and target aligning.
   */
  leftBottomEdge,

  /**
   * Appear to the right of the target element, with the top edges of the callout and target aligning.
   */
  rightTopEdge,

  /**
   * Appear to the right of the target element, with the centers of the callout and target aligning.
   */
  rightCenter,

  /**
   * Appear to the right of the target element, with the bottom edges of the callout and target aligning.
   */
  rightBottomEdge
}